import listActions from 'src/modules/ads/list/adsListActions';
import AdsService from 'src/modules/ads/adsService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ADS_DESTROY';

const adsDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: adsDestroyActions.DESTROY_STARTED,
      });

      await AdsService.destroyAll([id]);

      dispatch({
        type: adsDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.ads.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/ads');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: adsDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: adsDestroyActions.DESTROY_ALL_STARTED,
      });

      await AdsService.destroyAll(ids);

      dispatch({
        type: adsDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.ads.destroyAll.success'),
      );

      getHistory().push('/ads');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: adsDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default adsDestroyActions;
